module.exports = __webpack_public_path__ + "static/media/girl-1.baad9c46.svg";